export const randomPercent = () => {
  return Math.floor(Math.random() * 101)
}
